import React from 'react';
import { Link } from 'react-router-dom';
import { disciplines } from '../../data/site';
export function Methodes() {
  return <section id="methodes" className="bg-ivory" data-id="element-93" data-mp="rz6koq5d182n">
      <div className="mx-auto max-w-page px-6 py-20 lg:px-10 lg:py-28" data-id="element-94" data-mp="wxhwh6f7tsni">
        <div className="max-w-2xl" data-id="element-95" data-mp="wzksq86yoi0o">
          <h2 className="font-serif text-3xl font-light leading-tight text-ink sm:text-[2.75rem]" data-id="element-96" data-mp="10zl6rrq5er77">
            Trois méthodes qui se complètent
          </h2>
          <p className="mt-5 text-[1.0625rem] leading-relaxed text-ink/70" data-id="element-97" data-mp="15w26lj6pmu04">
            Elles ne s’opposent pas : elles couvrent la force, la mobilité et le relâchement. Selon votre état,
            nous choisissons ensemble celle qui vous sert le mieux, séance après séance.
          </p>
        </div>

        <dl className="mt-14 border-t border-ink/15" data-id="element-98" data-mp="1kp5bapz7dd9f">
          {disciplines.map(d => <div key={d.name} className="grid gap-4 border-b border-ink/15 py-9 lg:grid-cols-12 lg:gap-10 lg:py-11" data-id="element-99" data-mp="1omky0efpwowg">
              <dt className="lg:col-span-5" data-id="element-100" data-mp="m0oxldo8vpvp">
                <span className="font-serif text-2xl leading-snug text-ink sm:text-[1.75rem]" data-id="element-101" data-mp="lxj83xbpelzg">{d.name}</span>
                <span className="mt-2 block text-sm italic text-sage-deep" data-id="element-102" data-mp="i0erm10gczgu">{d.tagline}</span>
              </dt>
              <dd className="lg:col-span-7" data-id="element-103" data-mp="7zupyx90tsy3">
                <p className="max-w-2xl leading-relaxed text-ink/75" data-id="element-104" data-mp="815zzet27wxn">{d.description}</p>
                <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-sm text-ink/50" data-id="element-105" data-mp="15mlajibezzlu">
                  {d.details.map(detail => <li key={detail} data-id="element-106" data-mp="10qmq25t7j1qp">{detail}</li>)}
                </ul>
              </dd>
            </div>)}
        </dl>

        <Link to="/les-cours" className="mt-10 inline-block text-sm text-ink underline decoration-ink/25 decoration-1 underline-offset-[6px] transition-colors duration-150 ease-soft hover:decoration-ink" data-id="element-107" data-mp="qzibv8bcvkwx">
          Voir le détail des cours et des niveaux
        </Link>
      </div>
    </section>;
}